import React from "react";
import { CompanyAdminRequest } from "./CompanyAdminRequest/CompanyAdminRequest";

export const CompanyManage = () => {
  return <CompanyAdminRequest />;
};
